(function () {
  var ATTRIBUTION_KEY = 'ov_affiliate_attribution_v2';
  var SYNC_KEY = 'ov_affiliate_cart_sync_v2';
  var SESSION_KEY = 'ov_affiliate_session_v1';
  var VISITOR_KEY = 'ov_affiliate_visitor_v1';
  var PENDING_CART_KEY = 'ov_affiliate_pending_cart_v1';
  var HEALTH_KEY = 'ov_affiliate_health_v1';
  var ATTRIBUTION_TTL = 30 * 24 * 60 * 60 * 1000;
  var HEALTH_TTL = 24 * 60 * 60 * 1000;
  var lastAddToCart = {key: '', at: 0};
  var cartHasItems = null;
  var trackingSessionPromise = Promise.resolve(null);
  var attributionReady = Promise.resolve();
  var attributionReadyDone = true;
  var checkoutBypass = false;

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Attribution still works for the current page when browser storage is blocked.
    }
  }

  function storageRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Storage cleanup is best effort only.
    }
  }

  function validSlug(value) {
    var slug = String(value || '').trim().toLowerCase();
    return /^[a-z0-9][a-z0-9_-]{0,99}$/.test(slug) ? slug : '';
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'ovn-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function sessionId() {
    var current = storageGet(window.sessionStorage, SESSION_KEY);
    if (current) return current;
    current = eventId();
    storageSet(window.sessionStorage, SESSION_KEY, current);
    return current;
  }

  function visitorId() {
    var current = storageGet(window.localStorage, VISITOR_KEY);
    if (current) return current;
    current = eventId();
    storageSet(window.localStorage, VISITOR_KEY, current);
    return current;
  }

  function currentProductGid(detail) {
    var numericId = detail && detail.data && detail.data.productId;
    if (!numericId && window.ShopifyAnalytics && window.ShopifyAnalytics.meta) {
      numericId = window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.id;
    }
    if (!numericId) return null;
    var value = String(numericId);
    return value.indexOf('gid://') === 0 ? value : 'gid://shopify/Product/' + value;
  }

  function currentAttribution() {
    var params = new URLSearchParams(window.location.search);
    var explicitSlug = validSlug(params.get('affiliate_ref'));
    if (!explicitSlug && params.get('utm_source') === 'affiliate') {
      explicitSlug = validSlug(params.get('utm_content'));
    }

    if (explicitSlug) {
      var attribution = {
        slug: explicitSlug,
        campaign: validSlug(params.get('affiliate_campaign')) || validSlug(params.get('utm_campaign')),
        linkCode: validSlug(params.get('affiliate_link')),
        source: 'affiliate',
        capturedAt: Date.now(),
        isNew: true,
      };
      return attribution;
    }

    var stored = storageGet(window.localStorage, ATTRIBUTION_KEY);
    if (!stored) return null;

    try {
      var attribution = JSON.parse(stored);
      if (!validSlug(attribution.slug)) return null;
      if (Date.now() - Number(attribution.capturedAt || 0) > ATTRIBUTION_TTL) return null;
      attribution.slug = validSlug(attribution.slug);
      attribution.campaign = validSlug(attribution.campaign);
      attribution.linkCode = validSlug(attribution.linkCode);
      attribution.isNew = false;
      return attribution;
    } catch (error) {
      return null;
    }
  }

  function sendEvent(eventType, attribution, detail) {
    if (!attribution || !attribution.slug) return Promise.resolve(false);
    return trackingSessionPromise.then(function (trackingSession) {
      if (!trackingSession || !trackingSession.token) return false;
      var payload = {
        eventType: eventType,
        eventId: eventId(),
        sessionId: sessionId(),
        visitorId: visitorId(),
        trackingToken: trackingSession.token,
        path: window.location.pathname + window.location.search,
        productGid: currentProductGid(detail),
        metadata: {
          referrer: String(document.referrer || '').slice(0, 500),
          source: detail && detail.data ? String(detail.data.source || '').slice(0, 100) : '',
          variantId: detail && detail.data ? String(detail.data.variantId || '').slice(0, 100) : '',
        },
      };

      return fetch('/apps/affiliate?action=event', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: eventType === 'checkout' || eventType === 'add_to_cart',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
        },
        body: JSON.stringify(payload),
      }).then(function (response) {
        return response.ok;
      }).catch(function () {
        return false;
      });
    });
  }

  function startTrackingSession(attribution) {
    if (!attribution || !attribution.slug) return Promise.resolve(null);
    return fetch('/apps/affiliate?action=session', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {accept: 'application/json', 'content-type': 'application/json'},
      body: JSON.stringify({
        affiliateSlug: attribution.slug,
        campaignSlug: attribution.campaign,
        linkCode: attribution.linkCode,
        sessionId: sessionId(),
        visitorId: visitorId(),
        path: window.location.pathname + window.location.search,
      }),
    }).then(function (response) {
      return response.ok ? response.json() : null;
    }).then(function (payload) {
      return payload && payload.attributed && payload.token ? payload : null;
    }).catch(function () {
      return null;
    });
  }

  function trackAddToCart(attribution, detail) {
    var data = detail && detail.data ? detail.data : {};
    var key = String(data.variantId || data.productId || '') + '|' + window.location.pathname;
    var now = Date.now();
    if (lastAddToCart.key === key && now - lastAddToCart.at < 1500) return;
    lastAddToCart = {key: key, at: now};
    sendEvent('add_to_cart', attribution, detail);
  }

  function updateCartState(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    cartHasItems = cart.item_count > 0;
  }

  function detailFromCartAdd(body, source) {
    var item = body && body.items && body.items.length ? body.items[0] : body;
    return {
      data: {
        source: source,
        productId: item && item.product_id ? item.product_id : '',
        variantId: item && item.variant_id ? item.variant_id : (item && item.id ? item.id : ''),
      },
    };
  }

  function installConfirmedCartTracking(attribution) {
    if (!attribution || !attribution.slug || typeof window.fetch !== 'function') return;
    var originalFetch = window.fetch.bind(window);

    originalFetch('/cart.js', {credentials: 'same-origin', headers: {accept: 'application/json'}})
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        updateCartState(cart);
        var pendingRaw = storageGet(window.sessionStorage, PENDING_CART_KEY);
        if (!pendingRaw || !cart || !Array.isArray(cart.items)) return;
        try {
          var pending = JSON.parse(pendingRaw);
          var fresh = Date.now() - Number(pending.at || 0) < 2 * 60 * 1000;
          var matched = fresh && cart.items.some(function (item) {
            return String(item.variant_id || item.id || '') === String(pending.variantId || '');
          });
          storageRemove(window.sessionStorage, PENDING_CART_KEY);
          if (matched) {
            cartHasItems = true;
            trackAddToCart(attribution, {data: pending});
          }
        } catch (error) {
          storageRemove(window.sessionStorage, PENDING_CART_KEY);
        }
      })
      .catch(function () {
        // Checkout tracking remains disabled until the cart is confirmed.
      });

    window.fetch = function () {
      var args = arguments;
      var request = args[0];
      var requestUrl = typeof request === 'string' ? request : (request && request.url ? request.url : '');
      var isCartAdd = /\/cart\/add(?:\.js)?(?:\?|$)/.test(requestUrl);
      return originalFetch.apply(window, args).then(function (response) {
        if (!isCartAdd || !response.ok) return response;
        response.clone().json().then(function (body) {
          cartHasItems = true;
          trackAddToCart(attribution, detailFromCartAdd(body, 'confirmed-cart-add'));
        }).catch(function () {
          // A successful non-JSON response is left to the theme cart event.
        });
        return response;
      });
    };

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !/\/cart\/add(?:\.js)?(?:\?|$)/.test(String(form.action || ''))) return;
      var variant = form.querySelector('[name="id"]');
      if (!variant || !variant.value) return;
      storageSet(window.sessionStorage, PENDING_CART_KEY, JSON.stringify({
        source: 'confirmed-form-navigation',
        variantId: String(variant.value),
        productId: String(form.dataset.productId || ''),
        at: Date.now(),
      }));
    }, true);
  }

  function syncAttribution(attribution) {
    if (!attribution) return Promise.resolve(false);
    var syncValue = attribution.slug + '|' + attribution.campaign + '|' + attribution.linkCode + '|' + String(attribution.capturedAt || '');
    if (storageGet(window.sessionStorage, SYNC_KEY) === syncValue) return Promise.resolve(true);

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          'OVN Affiliate Slug': attribution.slug,
          'OVN Affiliate Campaign': attribution.campaign || '',
          'OVN Affiliate Link': attribution.linkCode || '',
          'OVN Affiliate Captured At': new Date(Number(attribution.capturedAt || Date.now())).toISOString(),
          'OVN Affiliate Source': attribution.source || 'affiliate',
          'OVN Affiliate Session': sessionId(),
        },
      }),
    }).then(function (response) {
      if (response.ok) {
        storageSet(window.sessionStorage, SYNC_KEY, syncValue);
        return true;
      }
      return false;
    }).catch(function () {
      return false;
    });
  }

  function withTimeout(promise, timeoutMs) {
    return Promise.race([
      promise,
      new Promise(function (resolve) { setTimeout(resolve, timeoutMs); }),
    ]);
  }

  function acceleratedCheckoutElements() {
    return document.querySelectorAll(
      'shopify-accelerated-checkout, .shopify-payment-button, .shopify-payment-button__button'
    );
  }

  function checkoutElement(event) {
    var selector = 'a[href*="/checkout"], button[name="checkout"], [data-ov-affiliate-checkout], shopify-accelerated-checkout, .shopify-payment-button, .shopify-payment-button__button';
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i += 1) {
      var item = path[i];
      if (item && item.matches && item.matches(selector)) return item;
      if (item && item.closest) {
        var closest = item.closest(selector);
        if (closest) return closest;
      }
    }
    return null;
  }

  function lockAcceleratedCheckout() {
    if (attributionReadyDone) return;
    acceleratedCheckoutElements().forEach(function (element) {
      if (element.dataset.ovAffiliateLocked === '1') return;
      element.dataset.ovAffiliateLocked = '1';
      element.dataset.ovAffiliatePointerEvents = element.style.pointerEvents || '';
      element.style.pointerEvents = 'none';
      element.setAttribute('aria-busy', 'true');
    });
  }

  function releaseAcceleratedCheckout() {
    acceleratedCheckoutElements().forEach(function (element) {
      if (element.dataset.ovAffiliateLocked !== '1') return;
      element.style.pointerEvents = element.dataset.ovAffiliatePointerEvents || '';
      element.removeAttribute('aria-busy');
      delete element.dataset.ovAffiliateLocked;
      delete element.dataset.ovAffiliatePointerEvents;
    });
  }

  function resumeCheckout(checkout) {
    checkoutBypass = true;
    if (checkout.tagName === 'A' && checkout.href) {
      checkoutBypass = false;
      window.location.assign(checkout.href);
      return;
    }
    if (checkout.form && typeof checkout.form.requestSubmit === 'function') {
      checkout.form.requestSubmit(checkout);
      checkoutBypass = false;
      return;
    }
    checkout.click();
  }

  function healthPing() {
    var lastCheck = Number(storageGet(window.localStorage, HEALTH_KEY) || 0);
    if (Date.now() - lastCheck < HEALTH_TTL) return;
    storageSet(window.localStorage, HEALTH_KEY, String(Date.now()));
    if (Math.random() > 0.05) return;

    fetch('/apps/affiliate?health=1', {
      credentials: 'same-origin',
      headers: {accept: 'application/json'},
    }).catch(function () {
      // Health monitoring must never interrupt the storefront.
    });
  }

  var attribution = currentAttribution();
  trackingSessionPromise = startTrackingSession(attribution);
  attributionReadyDone = !attribution;
  attributionReady = trackingSessionPromise.then(function (trackingSession) {
    if (!trackingSession || !trackingSession.token) return false;
    if (attribution && attribution.isNew) {
      storageSet(window.localStorage, ATTRIBUTION_KEY, JSON.stringify(attribution));
    }
    return syncAttribution(attribution);
  })
    .finally(function () {
      attributionReadyDone = true;
      releaseAcceleratedCheckout();
    });
  if (attribution) {
    lockAcceleratedCheckout();
    var checkoutObserver = new MutationObserver(lockAcceleratedCheckout);
    checkoutObserver.observe(document.documentElement, {childList: true, subtree: true});
    withTimeout(attributionReady, 1500).finally(function () {
      attributionReadyDone = true;
      checkoutObserver.disconnect();
      releaseAcceleratedCheckout();
    });
  }
  if (attribution) sendEvent('click', attribution);
  installConfirmedCartTracking(attribution);

  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    if (detail.data && detail.data.didError) return;
    if (!detail.data || (!detail.data.productId && !detail.data.variantId)) return;
    trackAddToCart(attribution, detail);
  });

  document.addEventListener('click', function (event) {
    var checkout = checkoutElement(event);
    if (!checkout || checkoutBypass) {
      checkoutBypass = false;
      return;
    }
    if (cartHasItems !== false) sendEvent('checkout', attribution);
    if (attribution && !attributionReadyDone) {
      event.preventDefault();
      event.stopImmediatePropagation();
      withTimeout(attributionReady, 1200).finally(function () { resumeCheckout(checkout); });
    }
  }, true);

  healthPing();
})();
